import { buildRecipeScaleTargets, scaleTarget } from './batch.js'

// A failed request must not silently turn an operational sheet into a base recipe.
export async function loadMenuRecipeScales(recipes, ordering, scaleRecipe) {
  const targets = buildRecipeScaleTargets(ordering)
  const entries = await Promise.all(recipes.map(async (recipe) => {
    const id = recipe.db_id ?? recipe.id
    const requirement = targets.get(String(id))
    if (!requirement) return null
    const target = scaleTarget(recipe.base_batch_unit, requirement.portionCount, requirement.lbsNeeded)
    if (target == null) return null
    return [id, await scaleRecipe(id, target)]
  }))
  return Object.fromEntries(entries.filter(Boolean))
}
